import ApiService from "./api.service";
const Measurement = {
  setHeight: async function (constraction_id, newHeight) {
    await ApiService.patch("/measurement/" + constraction_id+'/height', {
      height: newHeight
    });
    return true;
  },
  setRooms: async function (constraction_id, newRooms) {
    await ApiService.patch("/measurement/" + constraction_id+'/rooms', {
      rooms: newRooms
    });
    return true;
  },
  setTiles: async function (constraction_id, newTiles) {
    await ApiService.patch("/measurement/" + constraction_id+'/tiles', {
      tiles: newTiles
    });
    return true;
  },
  setItems: async function (constraction_id, newTiles) {
    await ApiService.patch("/measurement/" + constraction_id+'/items', {
      items: newTiles
    });
    return true;
  },
  
};

export default Measurement;